import React, { useRef, useState } from 'react'
import { useEffect } from 'react';
import axios from 'axios';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import './Cashflow.css'
import { Toast } from 'primereact/toast'
import { Api } from '../../../services/api';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { classNames } from 'primereact/utils';
import { CommonService } from '../../../services/commonService';
import { Button } from 'primereact/button';
import { FaFileExcel } from 'react-icons/fa';
import { IoMdRefresh } from "react-icons/io";

const Cashfloww = () => {
  const toast = useRef(null);
  const [projects, setProjects] = useState([]);
  const [columnName, setColumnName] = useState([]);
  const [RowName, setRowName] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [expandedRows, setExpandedRows] = useState([]);
  const [yearList, setYearlist] = useState([]);
  const [startYear, setStartYear] = useState(2023);
  const [endYear, setEndYear] = useState(2024);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectOnStartDate, setSelectOnStartDate] = useState('2025-01-01')
  const [selectOnEndDate, setSelectOnEndDate] = useState('2025-12-31')

  useEffect(() => {
    getProject();
    selectDate()

  }, []);

  //API call to get projects  
  const getProject = () => {
    setIsLoading(true);

    var _body = {
      start_year: startYear,
      end_year: endYear
    }

    const token = localStorage.getItem('authToken');

    // Create headers with token if it exists
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    };
    fetch(Api.API_BASE_URL + 'get-cashflow', {
      method: "GET",
      headers: headers
    })
      .then((response) => response.json())
      .then((response) => {

        setProjects(response.project)
        setColumnName(response.ColumnName)
        setIsLoading(false);

        var dea = [];

        if (response.project.length != 0) {
          response.project.forEach(element => {
            const isNameExist = dea.some(item => item.projectType === element.projectType);
            if (isNameExist) {
            } else {
              dea.push(element);
            }
          })
        }


        setExpandedRows(dea);

        var arr2 = [];
        response.ColumnName.forEach(element => {

          var ar = [{
            field: element,
            name: response.RowName[0],

          },
          {
            field: element,
            name: response.RowName[1],

          }, {
            field: element,
            name: response.RowName[2],

          }
            , {
            field: element,
            name: response.RowName[3],

          }]

          var mergedArray = arr2.concat(ar);
          arr2 = mergedArray;

        });

        setRowName(arr2);

      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error:", error);
      });

  }

  //Date Selection
  const selectDate = () => {
    const token = localStorage.getItem('authToken');

    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    };

    axios.get(Api.API_BASE_URL + 'get-startDate-endDate', { headers })
      .then((response) => {
        console.log('response', response.data.result);
        if (response.data.result.startDate && response.data.result.endDate) {
          // If dates are coming from the backend, set them
          setSelectOnStartDate(response.data.result.startDate);
          setSelectOnEndDate(response.data.result.endDate);
        } else {
          // If no dates are coming from the backend, set initial dates
          setSelectOnStartDate('2025-01-01'); // Initial start date
          setSelectOnEndDate('2025-12-31');   // Initial end date
        }
      })
      .catch((error) => {
        console.error('Error fetching projects:', error);
      });
  }



  /* --------------------------------------------------------------------------- */
  /* CSS GRID IMPLEMENTATION (Production Schedule Clone) */
  /* --------------------------------------------------------------------------- */

  const formatCurrency = (value) => {
    if (value === null || value === undefined || value === "") return "";
    return value.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  };

  const getColumnsConfig = () => {
    // Defines static columns logic.
    // Widths are approximations based on "minWidth" in DataTable code.
    const cols = [
      { 
        field: "projectName", 
        header: "Name", // Simplified header like prod schedule or keep full? DataTable has no header for first column? No, headerColumnGroup defines it.
        width: 300, 
        frozen: true, 
        render: (r) => {
            const name = r.projectName;
            if (name === 'Active Commercial') return 'Contract Commercial';
            if (name === 'Active Custom Homes') return 'Contract Custom Homes';
            if (name === 'Active Multi Family') return 'Contract Multi Family';
            if (name === 'Active Renovations') return 'Contract Renovations';
            if (name === 'Active Tenant Improvements') return 'Contract Tenant Improvements';
            if (name === 'Active Service & Maintenance') return 'Contract Service & Maintenance';
            return name;
        }
      },
      { field: "actual_start_date_pm", header: "Start Date", width: 120, render: (r) => DateViewTable(r.actual_start_date_pm) },
      { field: "actual_complation_date_pm", header: "Comp. Date", width: 120, render: (r) => DateViewTable(r.actual_complation_date_pm) },
      { field: "final_complation_date", header: "Final Comp.", width: 120, render: (r) => DateViewTable(r.final_complation_date) },
      { field: "monthLeft", header: "Months Left", width: 100 },
      // Financials
      { field: "orig_expected_gp", header: "Orig Exp GP", width: 120, render: (r) => priceBodyTemplate(r.orig_expected_gp) },
      { field: "orig_gp_month", header: "Orig GP/Mo", width: 120, render: (r) => priceBodyTemplate(r.orig_gp_month) },
      { field: "newExpectedGP", header: "New Exp GP", width: 120, render: (r) => priceBodyTemplate(r.newExpectedGP) },
      { field: "updatedGPMonth", header: "Upd GP/Mo", width: 120, render: (r) => priceBodyTemplate(r.updatedGPMonth) },
      { field: "gpTermofProjectperMonth", header: "GP Term/Mo", width: 120, render: (r) => priceBodyTemplate(r.gpTermofProjectperMonth) },
      { field: "gpTermofProject", header: "GP Term Total", width: 120, render: (r) => priceBodyTemplate(r.gpTermofProject) },
      { field: "perofGPSlippage", header: "% GP Slip", width: 120, render: (r) => priceBodyPer(r.perofGPSlippage, r) },
      
      { field: "contract_amount", header: "Contract Amt", width: 120, render: (r) => priceBodyTemplate(r.contract_amount) },
      { field: "projectCostFees", header: "Proj Cost Fees", width: 120, render: (r) => priceBodyTemplate(r.projectCostFees) },
      { field: "margin", header: "Margin %", width: 80, render: (r) => priceBodyPer(r.margin, r) },
      
      { field: "actuals_to_date", header: "Actuals To Date", width: 120, render: (r) => priceBodyTemplate(r.actuals_to_date) },
      { field: "actuals_fee", header: "Actuals Fee", width: 120, render: (r) => priceBodyTemplate(r.actuals_fee) },
      
      { field: "feesTotal", header: "Fees Total", width: 120, render: (r) => priceBodyTemplate(r.feesTotal) },
      { field: "feesToDate", header: "Fees To Date", width: 120, render: (r) => priceBodyTemplate(r.feesToDate) },
      { field: "feesLeft", header: "Fees Left", width: 120, render: (r) => priceBodyTemplate(r.feesLeft) },
      { field: "fessPerMonth", header: "Fees/Mo", width: 120, render: (r) => priceBodyTemplate(r.fessPerMonth) },
      
      { field: "directCostRemaining", header: "Dir Cost Rem", width: 120, render: (r) => priceBodyTemplate(r.directCostRemaining) },
      { field: "directcostperMonth", header: "Dir Cost/Mo", width: 120, render: (r) => priceBodyTemplate(r.directcostperMonth) },
      
      { field: "fixedPrice", header: "Fixed Price", width: 120, render: (r) => priceBodyTemplate(r.fixedPrice) },
      { field: "fixedMonth", header: "Fixed Month", width: 120 },
      
      { field: "complete", header: "% Comp (User)", width: 80, render: (r) => priceBodyPer(r.complete, r) },
      { field: "overUnderBilling", header: "Over/Under", width: 120, render: (r) => priceBodyTemplate(r.overUnderBilling) },
      { field: "revenueEarnedToDate", header: "Rev Earned", width: 120, render: (r) => priceBodyTemplate(r.revenueEarnedToDate) },
      { field: "overallPersanatage", header: "% Comp (Calc)", width: 120, render: (r) => priceBodyPer(r.overallPersanatage, r) },
      
      // Spacer
      { field: "spacer", header: "", width: 20, render: () => null }
    ];
    return cols;
  };

  const renderGrid = () => {
    // 1. Config & Columns
    const staticCols = getColumnsConfig();
    const monthlyLeafCols = [];

    // Flatten monthly structure
    if (columnName && columnName.length > 0) {
      columnName.forEach(month => {
        if (showMonthIs(month)) {
          const subCols = RowName.filter(r => r.field === month);
          subCols.forEach(sub => {
            monthlyLeafCols.push({ field: month, subField: sub.name, width: 100, parentHeader: month });
          });
        }
      });
    }

    const totalCols = [...staticCols, ...monthlyLeafCols];
    const gridTemplate = totalCols.map(c => `${c.width}px`).join(" ");
    
    // 2. Build Grid Items
    const gridItems = [];
    
    // --- HEADERS ---
    
    // A. Static Headers (Row 1, span 2 rows)
    let cIdx = 1;
    staticCols.forEach(col => {
      const isFrozen = col.frozen;
      const style = {
        gridColumn: `${cIdx} / span 1`,
        gridRow: "1 / span 2",
        width: col.width,
        minWidth: col.width,
        left: isFrozen ? 0 : undefined,
        top: 0,
        height: "80px", // Double height
        display: "flex", alignItems: "center", justifyContent: "center",
        zIndex: isFrozen ? 30 : 20
      };
      let cls = "cf-grid-cell cf-grid-header";
      if (isFrozen) cls += " cf-col-sticky-1";
      
      gridItems.push(<div key={`h-static-${col.field}`} className={cls} style={style}>{col.header}</div>);
      cIdx++;
    });
    
    // B. Month Headers (Row 1, span N columns)
    const uniqueMonths = [...new Set(monthlyLeafCols.map(c => c.parentHeader))];
    let monthStartCol = cIdx;
    
    uniqueMonths.forEach(month => {
      const subCols = monthlyLeafCols.filter(c => c.parentHeader === month);
      const span = subCols.length;
      
      // Top Level Header
      const style = {
        gridColumn: `${monthStartCol} / span ${span}`,
        gridRow: "1 / span 1",
        top: 0, 
        height: "40px",
        display: "flex", alignItems: "center", justifyContent: "center",
        zIndex: 10,
        borderBottom: "1px solid #ddd" // Separator from sub-header
      };
      
      gridItems.push(
        <div key={`h-month-${month}`} className="cf-grid-cell cf-grid-header" style={style}>
          {month}
        </div>
      );
      
      // Sub Headers (Row 2) - Logic is getting tricky with loop, but we can just render them relative to start
      subCols.forEach((sub, idx) => {
        const subStyle = {
           gridColumn: `${monthStartCol + idx} / span 1`,
           gridRow: "2 / span 1",
           top: "40px",
           height: "40px",
           width: sub.width,
           minWidth: sub.width,
           zIndex: 10,
           display: "flex", alignItems: "center", justifyContent: "center"
        };
        gridItems.push(
           <div key={`h-sub-${month}-${sub.subField}`} className="cf-grid-cell cf-grid-header" style={subStyle}>
             {sub.subField}
           </div>
        );
      });
      
      monthStartCol += span;
    });

    // --- BODY ---
    let currentGroup = null;
    projects.forEach((row, rIdx) => {
        // Group Header
        if (row.projectType !== currentGroup) {
            currentGroup = row.projectType;
            // Sticky Group Label
            gridItems.push(
                <div key={`g-label-${rIdx}`} className="cf-group-header-label" style={{ gridColumn: "1 / span 1" }}>
                   <i className="pi pi-circle-fill" style={{ color: "#" + (row.projectTypeColorCode || "ccc"), marginRight: 8 }}></i>
                   {currentGroup}
                </div>
            );
            // Filler
            gridItems.push(
                <div key={`g-filler-${rIdx}`} className="cf-group-header-filler" style={{ gridColumn: "2 / -1" }}></div>
            );
        }
        
        // Data Cells
        let cellCol = 1;
        
        // Static Cells
        staticCols.forEach(col => {
            const isFrozen = col.frozen;
            const style = {
                gridColumn: `${cellCol} / span 1`,
                width: col.width,
                minWidth: col.width,
                left: isFrozen ? 0 : undefined
            };
            let cls = "cf-grid-cell";
            if (isFrozen) {
                cls += " cf-col-sticky-1";
                style.borderLeft = `5px solid #${row.projectTypeColorCode || 'fff'}`;
            }

            let content = col.render ? col.render(row) : row[col.field];
            
            // Name Styling
            if (col.field === 'projectName') {
                content = (
                    <div style={{ fontWeight: 500, color: '#111827', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={String(content)}>
                        {content}
                    </div>
                );
            } else {
                // Center align all other columns (assuming they are numbers or dates)
                style.justifyContent = 'center';
                style.textAlign = 'center';
            }
            
            gridItems.push(<div key={`r${rIdx}-c${cellCol}`} className={cls} style={style}>{content}</div>);
            cellCol++;
        });
        
        // Month Cells
        monthlyLeafCols.forEach(col => {
            const style = {
                gridColumn: `${cellCol} / span 1`,
                width: col.width,
                minWidth: col.width,
                justifyContent: 'center', // Center align monthly data
                textAlign: 'center'
            };
            
            let val = "";
            try {
                if (row[col.field] && row[col.field][col.subField] !== undefined) {
                    val = row[col.field][col.subField];
                }
            } catch (e) {}
            
            const content = priceBodyTemplate(val);
            
             // Variance Column styling
            if (col.subField === 'Variance PM') {
                style.borderRight = "1px solid #94a3b8"; // Lighter border
            }
            
            gridItems.push(<div key={`r${rIdx}-m${col.field}-${col.subField}`} className="cf-grid-cell" style={style}>{content}</div>);
            cellCol++;
        });
    });

    if (projects.length === 0) return <div className="p-4 text-center">No projects found.</div>;

    return (
        <div className="cf-scroll-container">
            <div className="cf-grid-container" style={{ gridTemplateColumns: gridTemplate }}>
                {gridItems}
            </div>
        </div>
    );
  };



  const lastYearSaleBodyTemplate = (col, rowname, rowData) => {
    if (rowData && rowData[col.field] && rowData[col.field][rowname] !== undefined) {
      return priceBodyTemplate(rowData[col.field][rowname]);
    }
    return "";
  };

  const showMonthIs = (myString) => {
    var myArray = myString.split(' ');

    var arr = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",];
    var index = arr.indexOf(myArray[0]) + 1;

    var year = myArray[1];
    if (myArray[0] === 'Year') {
      return true;
      // index = 12;
    }

    var year = myArray[1];
    if (myArray[0] === 'QUARTER') {
      year = myArray[2]
      if (myArray[1] == '1') {
        index = 3;
      }
      if (myArray[1] == '2') {
        index = 6;
      }
      if (myArray[1] == '3') {
        index = 9;
      }
      if (myArray[1] == '4') {
        return true;
        // index = 12;
      }

    }

    let startDate = selectOnStartDate;
    let endDate = selectOnEndDate;

    const date1 = new Date(startDate);
    const date2 = new Date(endDate);
    
    const month = new Date(year + '-' + index + '-01');
    
    // Extract year and month from date1 and date2
    const year1 = date1.getFullYear();
    const month1 = date1.getMonth();

    const year2 = date2.getFullYear();
    const month2 = date2.getMonth();

    // Extract year and month from the target month
    const targetYear = month.getFullYear();
    const targetMonth = month.getMonth();

    // Check if the target month falls within the date range
    if (
      (targetYear > year1 || (targetYear === year1 && targetMonth >= month1)) &&
      (targetYear < year2 || (targetYear === year2 && targetMonth <= month2))
    ) {

      return true;
    } else {

      return false;
    }

    return false;
  }


  /* Unused components removed: headerGroup, headerTemplate */


  const priceBodyTemplate = (rowData) => {
    if (rowData === '') {
      return '';
    }

    if (typeof rowData === 'string') {
      rowData = parseInt(rowData, 10);
    }

    const isNegative = rowData < 0; // Check if the value is negative

    return (
      <div style={{
        color: isNegative ? "red" : "black",
        // backgroundColor: isNegative ? "#fcd9d9" : "", 
        // height: '36px',
        // paddingTop: '8px',
        // border: isNegative ? '1px solid red' : '' 
      }}>

        {formatCurrency(rowData)}
      </div>
    );
  };

  const priceBodyPer = (rowData, allData) => {
    if (rowData === '') {
      return '';
    }
    let numberValue = Number(rowData); // Convert to a number if it's a string
    // Ensure rowData is a number after the conversion and it's not NaN
    if (isNaN(numberValue)) {
      console.error("rowData is not a number");
      return '';
    }
    const keyExists = allData.hasOwnProperty('no_of_project');
    // console.log(keyExists);
    if (keyExists) {
      numberValue = numberValue / allData.no_of_project;
    }
    const isNegative = numberValue < 0;
    return <div style={{
      color: isNegative ? "red" : "black",
      // backgroundColor: isNegative ? "#fcd9d9" : "",
      // height: '36px',
      // paddingTop: '8px',
      // border: isNegative ? '1px solid red' : ''
    }}>
      {numberValue.toFixed(2) + '%'}
    </div>;
  };





  const DateViewTable = (value) => {
    var t = value;
    if (value == "0000-00-00") {
      t = '';
    }
    if (value != null) {
      let timestamp = new Date(value);



      if (!isNaN(timestamp.getTime())) {
        value = timestamp.toISOString().split('T')[0];
        return value;
      }
    }
    return t;
  }

  const handleOnSubmit = () => {
    if (startYear > endYear) {
      toast.current.show({ severity: 'error', summary: 'Error', detail: 'Start year should be less than end year', life: 3000 });
      return;
    } else {
      setIsLoading(true);
      StartDateAndEndDateSelect();
      getProject();
    }
  };

  const StartDateAndEndDateSelect = () => {
    const startDate = new Date(selectOnStartDate);
    const endDate = new Date(selectOnEndDate);

    if (startDate > endDate) {
      toast.current.show({ severity: 'error', summary: 'Error', detail: 'Start date should be before end date.' });
      return;
    }
    updateDateInBackend(selectOnStartDate, selectOnEndDate);

    localStorage.setItem('startYear', selectOnStartDate);
    localStorage.setItem('endYear', selectOnEndDate);
  }

  const updateDateInBackend = (startDate, endDate) => {
    setIsLoading(true);
    var _body = {
      startDate: startDate,
      endDate: endDate
    }
    const token = localStorage.getItem('authToken');

    // Create headers with token if it exists
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    };
    fetch(Api.API_BASE_URL + 'change-startDate-endDate/1', {
      method: "POST",
      body: JSON.stringify(_body),
      headers: headers
    })
      .then((response) => response.json())
      .then((response) => {
        // setIsLoading(false);
        getProject();
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error:", error);
      });
  }

  const exportExcel = () => {
    import('xlsx').then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(projects);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      });

      saveAsExcelFile(excelBuffer, 'products');
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import('file-saver').then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data = new Blob([buffer], {
          type: EXCEL_TYPE
        });

        module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
      }
    });
  };

  const renderHeader = () => {
    return (
      <div className="dashboard-toolbar">
         <div className="action-buttons" style={{ borderLeft: 'none', paddingLeft: 0, marginLeft: 0 }}>
            <button type="button" className="btn-modern btn-secondary" onClick={exportExcel} title="Download Excel">
                <FaFileExcel /> 
                <span>Excel</span>
            </button>
            <button type="button" className="btn-modern btn-primary" onClick={handleOnSubmit} title="Save & Refresh">
               <IoMdRefresh /> 
               <span>Refresh</span>
            </button>
         </div>

         <div className="toolbar-controls" style={{ marginLeft: "auto" }}>
            <div className="control-group">
                <label>Start Date</label>
                <InputText
                  type="date"
                  className="modern-input"
                  value={selectOnStartDate}
                  onChange={(e) => setSelectOnStartDate(e.target.value)}
                />
            </div>
            <div className="control-group">
                <label>End Date</label>
                <InputText
                  type="date"
                  className="modern-input"
                  value={selectOnEndDate}
                  onChange={(e) => setSelectOnEndDate(e.target.value)}
                />
            </div>
         </div>
      </div>
    );
  };

  const rowClass = (data) => {
    return {
      'bg-gray-300': data.projectType === 'TOTAL' || data.projectType === 'ZC FSA PROJECTIONS' || data.projectType === 'ZB FORECAST VS ACTULS' || data.projectType === 'ZD AJS PROJECTIONS' || data.projectType === 'ZE DIVISION PROJECTIONS'
    };
  };

  // const getMonthLeft = (data, complationDate) => {
  //   const completionDate = new Date(complationDate);

  //   // Get the current date
  //   const today = new Date();

  //   // Extract year and month components
  //   const todayYear = today.getFullYear();
  //   const todayMonth = today.getMonth() + 1; // Months are zero-based, so add 1

  //   const completionYear = completionDate.getFullYear();
  //   const completionMonth = completionDate.getMonth() + 1; // Months are zero-based, so add 1

  //   // Compare year and month components
  //   if (
  //     completionYear < todayYear ||
  //     (completionYear === todayYear && completionMonth < todayMonth)
  //   ) {
  //     return "";
  //   }
  //   return data;

  // }

  // const dateTimeOfFirstDay = (date) => {
  //   var myArray = date.split('-');
  //   if (myArray.length > 1) {
  //     return myArray[0] + '-' + myArray[1] + '-01';
  //   }
  // }

  return (
    <div className="dashboard-wrapper">
      <Toast ref={toast} />
      <div className="dashboard-content-card">
        {renderHeader()}
        {isLoading ? (
          <div className="loading-spinner">
            Loading...
            <div className="spinner"></div>
          </div>
        ) : (
          <div className="table-responsive-wrapper" style={{ overflow: "hidden" }}>
            {/* Switched to Custom CSS Grid to match Production Schedule UI */}
            {renderGrid()}
          </div>
        )}

        {/* OBSOLETE DATATABLE REMOVED */}
      </div>
    </div>
  );
}

// export default Cashfloww
export default React.memo(Cashfloww);